module.exports = "https://web-assets.ifttt.com/packs/media/platform/Create_icon-31678ccd.svg";